module.exports = __webpack_public_path__ + "img/logo.8ab92ce5.svg";